import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';

import { INTL_LANGUAGE_SET, INTL_TIMEZONE_SET } from './actions';

export const INITIAL_STATE = Immutable({
  language: 'en-US',
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

export const actionMap = {
  [INTL_LANGUAGE_SET]: (state, { payload }) =>
    Immutable({ ...state, language: payload }),
  [INTL_TIMEZONE_SET]: (state, { payload }) =>
    Immutable({ ...state, timeZone: payload }),
};

export default handleActions(actionMap, INITIAL_STATE);
